import { SUBSCRIPTION_COMPONENT_TRANSLATIONS as T } from "@/components/subscription/constants";
import { Button } from "@/domains/shared/components/Button";
import { getTranslation } from "@mivo/i18n";

type PlanChangeConfirmStepProps = {
    currentPlanName: string;
    targetPlanName: string;
    isDowngrade: boolean;
    isUpgrade?: boolean;
    clinicRemains?: boolean;
    subscriptionCancelled: boolean;
    loading: boolean;
    onBack: () => void;
    onConfirm: () => void;
};

export default function PlanChangeConfirmStep({
    currentPlanName,
    targetPlanName,
    isDowngrade,
    isUpgrade = false,
    clinicRemains = false,
    subscriptionCancelled,
    loading,
    onBack,
    onConfirm,
}: PlanChangeConfirmStepProps) {
    return (
        <div className="space-y-4 text-sm text-muted-foreground" data-testid="plan-change-confirm-step">
            <p>
                {getTranslation(T.planChangeFromPrefix)}{" "}
                <strong className="text-secondary-foreground">{currentPlanName}</strong>{" "}
                {getTranslation(T.planChangeToConnector)}{" "}
                <strong className="text-secondary-foreground">{targetPlanName}</strong>.
            </p>
            {clinicRemains ? (
                <p data-testid="plan-change-clinic-remains">{getTranslation(T.planChangeClinicRemains)}</p>
            ) : null}
            {clinicRemains ? (
                <p data-testid="plan-change-downgrade-credit">{getTranslation(T.planChangeDowngradeCredit)}</p>
            ) : null}
            {isDowngrade ? <p>{getTranslation(T.planChangeDowngradeImmediate)}</p> : null}
            {isUpgrade ? <p>{getTranslation(T.planChangeUpgradeImmediate)}</p> : null}
            {subscriptionCancelled ? <p>{getTranslation(T.planChangeReactivatesRenewal)}</p> : null}
            <div className="flex flex-row gap-2">
                <Button variant="outline" className="flex-1" onClick={onBack}>
                    {getTranslation(T.back)}
                </Button>
                <Button className="flex-1" isLoading={loading} onClick={onConfirm}>
                    {getTranslation(T.confirmPlanChange)}
                </Button>
            </div>
        </div>
    );
}
